<div class="content"> 
 
<h4 style="margin-left: 20px;">Tasks</h4> 
 

<!-- <h3>Raised Buttons</h3>
<div class="example-button-row">
  <button mat-raised-button>Basic</button>
  <button mat-raised-button class="primary">Primary</button>
  <button mat-raised-button color="accent">Accent</button>
  <button mat-raised-button color="warn">Warn</button>
  <button mat-raised-button disabled>Disabled</button>
  <a mat-raised-button routerLink=".">Link</a>
</div>
 <br> -->
<br>
 
  <button mat-raised-button class="primary" style="margin-left: 20px;" (click)="openProjectTaskAdd()"> 
    <mat-icon class="mr">add</mat-icon>Add Task</button>

<!--  
        <button mat-raised-button> 
          <mat-icon class="mr">menu</mat-icon>Done
          </button> -->
       
<br>
<br>
 

<span *ngIf="!isMobile"> 
<mat-table *ngIf="dataSource" [dataSource]="dataSource" >

  
    <ng-container *ngFor="let column of ProjectTaskColumns" [matColumnDef]="column">
  
      <th mat-header-cell *matHeaderCellDef style="width: 210px; text-transform: uppercase;" ><span *ngIf="column != 'edit'"></span> 
       {{ column }}</th> 
      <!-- <mat-header-cell *matHeaderCellDef>
    
    <td>{{ column }}</td>
    </mat-header-cell>  -->
  <!-- <mat-cell *matCellDef="let element">{{ element[column] }}</mat-cell>  -->
  
  
<td mat-cell *matCellDef="let element">
  <div *ngIf="element !== editedRow; else editCell">


    <span  *ngIf="column == 'cost' || column == 'productPrice'">
    {{ element[column]  | currency }}   
 </span>
 <span  *ngIf="column == 'completed'">
  <span [ngClass]="{'text-green-600': element.completed, 'text-red-600': !element.completed}">
    {{ element.completed ? 'Completed' : 'Not Completed' }}
  </span>
</span>
<span  *ngIf="column != 'cost' && column != 'productPrice' && column != 'completed'">
  {{ element[column] }}   
</span>
 
    <span  *ngIf="column == 'edit'">
    <button mat-icon-button (click)="editRow(element)" >
    <mat-icon>edit</mat-icon>
     </button>
   
     <button mat-icon-button (click)="removeTaskfromProject(element)" >
      <mat-icon>delete</mat-icon>
       </button> 
   
    </span>
  </div>
  <ng-template #editCell>
     
    <span *ngIf="column != 'edit'">
      <ng-container [ngSwitch]="column">
        <ng-container *ngSwitchCase="'completed'">
          <mat-select [(ngModel)]="element.completed" (selectionChange)="saveEdit(element)" style="min-width: 120px;">
            <mat-option [value]="true">Completed</mat-option>
            <mat-option [value]="false">Not Completed</mat-option>
          </mat-select>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <input [(ngModel)]="element[column]" title="save" (blur)="saveEdit(element)" />
        </ng-container>
      </ng-container>
    </span>
    <span *ngIf="column == 'edit'">
       <button mat-icon-button (click)="cancelEdit(element)">
      <mat-icon>done</mat-icon>
    </button>
    </span>
  </ng-template> 
</td>

  </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="ProjectTaskColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: ProjectTaskColumns;"></tr>
  </mat-table>
</span>

<span *ngIf="isMobile">  

  <div *ngFor="let task of projectTasks" class="card">
     
    <div class="card-content">
      
 <table><tr>
  <td style="text-align: left;"><a mat-fab class="custom-fab" (click)="removeTaskfromProject(task)"><mat-icon>delete</mat-icon></a> </td>
  <td style="text-align: right;"> <a mat-fab class="custom-fab" (click)="editRow(task)"><mat-icon>edit</mat-icon></a></td>
</tr></table>
      

      <div class="card-row">
        <span class="card-label"><b>Title:</b></span>
        <span class="card-value">{{ task.title}}</span>
      </div>
      <div class="card-row"> 
          <span class="card-label"><b>Date:</b></span>
          
        <span class="card-value">{{ task.dueDate | date }}</span>
        
      </div>
        <div class="card-row">
        <span class="card-label"><b>Assigned To:</b></span>
          
        <span class="card-value">{{ task.assignedTo }} </span>
        </div>
         
      <!-- </div>
      <div class="card-row"> -->
        <!-- <span class="card-label"><b>Qty:</b></span>
        <span class="card-value">{{ material.qty }}</span> -->
      </div>
      <ng-template #editCell>
     
        
        <input [(ngModel)]="task.title" title="save" />
           <input [(ngModel)]="task.title" title="save" (blur)="saveEdit(task)" />
          
           <button mat-icon-button (click)="cancelEdit(task)">
          <mat-icon>done</mat-icon>
        </button>
  
      </ng-template> 
    </div> 
  
</span>








  
</div>